import { createStore, combineReducers, applyMiddleware, Middleware, AnyAction } from 'redux';
import thunk, { ThunkDispatch } from 'redux-thunk';
import autoMergeLevel2 from 'redux-persist/lib/stateReconciler/autoMergeLevel2';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { composeWithDevTools } from 'redux-devtools-extension';
import persistedUserData from './reducers/persistedUserData';
import app from './reducers/app';
import constants from './utils/constants';
import login_reducer from './reducers/login';
import message_reducer from './reducers/message';
import setting_reducer from './reducers/setting';
import review_order_reducer from './reducers/reviewOrder';
import catalog_mode_reducer from './reducers/catalog_mode';
import buyer_reducer from './reducers/buyer';
import { USER_LOGOUT } from './actions/reduxConstants';
import { replaceAuthUrlToHome } from './utils/authUrl';
import order_notifications_reducer from './reducers/orderNotifications';
import document_mode_reducer from './reducers/documentMode';
import impersonation_reducer from './reducers/impersonation';

const { VITE_APP_ENV } = import.meta.env;

const root_reducer: any = combineReducers({
	app,
	login: login_reducer,
	message: message_reducer,
	persistedUserData,
	settings: setting_reducer,
	reviewOrder: review_order_reducer,
	catalog_mode: catalog_mode_reducer,
	buyer: buyer_reducer,
	orderNotifications: order_notifications_reducer,
	documentMode: document_mode_reducer,
	impersonation: impersonation_reducer,
});

const authUrlOnLogoutMiddleware: Middleware = () => (next) => (action) => {
	if (action.type === USER_LOGOUT) {
		replaceAuthUrlToHome();
	}
	return next(action);
};

const persistConfig = {
	key: 'root',
	version: 1,
	storage,
	blacklist: Object.keys(root_reducer),
	whitelist: ['persistedUserData', 'buyer', 'impersonation'],
	stateReconciler: autoMergeLevel2,
};

const persisted_reducer = persistReducer(persistConfig, root_reducer);

const middlewares = [authUrlOnLogoutMiddleware, thunk];

const store = createStore(
	persisted_reducer,
	VITE_APP_ENV === constants.ALL_ENV.PRODUCTION ? applyMiddleware(...middlewares) : composeWithDevTools(applyMiddleware(...middlewares)),
);

export type RootState = ReturnType<typeof root_reducer>;
export type AppDispatch = ThunkDispatch<RootState, unknown, AnyAction>;

export const persistor = persistStore(store);

export default store;
